import { useState } from "react";
import { injectIntl } from "react-intl";
import { intlShape } from "../../shapes";
import ActionButton from "./ActionButton";
import ConfirmationModal from "../ConfirmationModal";

type Props = {
  intl: intlShape;
  onConfirm?: $TSFixMeFunction;
  onClose?: $TSFixMeFunction;
  disabled?: boolean;
  modalTitle?: string;
  modalMessage?: React.ReactNode;
  onClick?: $TSFixMeFunction;
  buttonConfirmText?: string;
  buttonCancelText?: string;
  showCancel?: boolean;
};

function ExportActionButton(props: Props) {
  const [showExportModal, setShowModal] = useState(false);

  const onExportClick = () => {
    setShowModal(true);
    if (props.onClick) {
      props.onClick();
    }
  };

  const onConfirmClick = () => {
    setShowModal(false);
    if (props.onConfirm) {
      props.onConfirm();
    }
  };

  const onCloseClick = () => {
    setShowModal(false);
    if (props.onClose) {
      props.onClose();
    }
  };

  const model = props.disabled ? null : (
    <ConfirmationModal
      id="export-modal"
      show={showExportModal}
      titleText={props.modalTitle}
      messageText={props.modalMessage}
      buttonConfirmText={props.buttonConfirmText}
      buttonCancelText={props.buttonCancelText}
      showCancel={props.showCancel}
      onConfirm={onConfirmClick}
      onClose={onCloseClick}
    />
  );

  return (
    <span>
      <ActionButton
        {...props}
        icon="icon-eh-save"
        defaultLabel={props.intl.formatMessage({ id: "button.export" })}
        onClick={onExportClick}
      />
      {model}
    </span>
  );
}

export default injectIntl(ExportActionButton);
